import { render } from "./ActivityReport.vue?vue&type=template&id=5bb3f424&scoped=true"
import script from "./ActivityReport.vue?vue&type=script&lang=js"
export * from "./ActivityReport.vue?vue&type=script&lang=js"

import "./ActivityReport.vue?vue&type=style&index=0&id=5bb3f424&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb3f424"]])

export default __exports__